import { render, staticRenderFns } from "./Plateno.vue?vue&type=template&id=2bee6c82&scoped=true&"
import script from "./Plateno.vue?vue&type=script&lang=js&"
export * from "./Plateno.vue?vue&type=script&lang=js&"
import style0 from "./Plateno.vue?vue&type=style&index=0&id=2bee6c82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bee6c82",
  null
  
)

export default component.exports